import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage, auth } from "../firebase";
import { authenticateWithFirebase } from "./firebaseAuth";

export const uploadFileToFirebase = async (
  file: File,
  path: string
): Promise<string> => {
  try {
    const userSession = localStorage.getItem("userSession");
    const token = localStorage.getItem("token");

    if (!userSession || !token) {
      throw new Error(
        "Usuário não autenticado no sistema principal. Faça login novamente."
      );
    }

    try {
      const sessionData = JSON.parse(userSession);
      if (!sessionData || !sessionData.companyId) {
        throw new Error("Sessão inválida. Faça login novamente.");
      }
    } catch (parseError) {
      throw new Error("Sessão corrompida. Faça login novamente.");
    }

    if (!auth.currentUser) {
      const firebaseResponse = await authenticateWithFirebase();

      if (!firebaseResponse.success) {
        throw new Error(
          "Erro na autenticação do Firebase. Faça login novamente."
        );
      }
    }

    const storageRef = ref(storage, path);

    const snapshot = await uploadBytes(storageRef, file);

    const downloadURL = await getDownloadURL(snapshot.ref);

    return downloadURL;
  } catch (error) {
    console.error("Erro ao fazer upload do arquivo:", error);

    if (
      error &&
      typeof error === "object" &&
      "message" in error &&
      typeof error.message === "string"
    ) {
      if (
        error.message.includes("auth") ||
        error.message.includes("permission")
      ) {
        throw new Error(
          "Erro de permissão no Firebase. Verifique as regras de segurança."
        );
      }
    }

    throw new Error("Falha ao fazer upload do arquivo");
  }
};

export const uploadCompanyLogo = async (
  file: File,
  companyId: string | number
): Promise<string> => {
  const fileExtension = file.name.split(".").pop();
  const fileName = `${companyId}.${fileExtension}`;
  const path = `logos/${fileName}`;

  return await uploadFileToFirebase(file, path);
};

export const getCompanyLogoUrl = async (
  companyId: string | number,
  fileExtension: string = "png"
): Promise<string | null> => {
  try {
    const fileName = `${companyId}.${fileExtension}`;
    const path = `logos/${fileName}`;
    const storageRef = ref(storage, path);

    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    const extensions = ["jpg", "jpeg", "gif", "webp"];

    for (const ext of extensions) {
      try {
        const fileName = `${companyId}.${ext}`;
        const path = `logos/${fileName}`;
        const storageRef = ref(storage, path);

        const downloadURL = await getDownloadURL(storageRef);
        return downloadURL;
      } catch (err) {
        continue;
      }
    }

    return null;
  }
};

export const getCompanyLogoByUrl = async (
  logoUrl: string | null,
  companyId: string | number
): Promise<string | null> => {
  if (logoUrl) {
    if (logoUrl.includes("firebase") || logoUrl.includes("googleapis")) {
      return logoUrl;
    }

    try {
      const firebaseUrl = await getCompanyLogoUrl(companyId);
      return firebaseUrl;
    } catch (error) {
      console.log("Erro ao buscar logo do Firebase:", error);
      return logoUrl;
    }
  }

  return await getCompanyLogoUrl(companyId);
};
